// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"26cd324a","715":"8461ba83","884":"3e177243"}[chunkId] + ".js";
};